/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import RequestAction from './RequestAction/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/SendForSignatureAction/Empty"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let editorHasSignatureValueData = fromData.useDataFormat({ viewPath,
context: 'editor',
path: 'hasSignature',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: editorHasSignatureValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RequestAction'}>
<RequestAction
  viewPath={`${viewPath}/RequestAction`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}